// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editpersonalInfo-logo{
    width: 40px;
height: 40px


}
.EditInfoCont{
    background-color: white !important;
    /* width:100%; */
    padding: 20px;
    /* margin: 0 auto; */
    /* margin-right: 2% !important; */
    border-radius: 10px;
}

.editacc-title{
    align-self: center;
    font-family: "Inter";
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    letter-spacing: 0.02em;
    text-align: left;
    color:#00162E !important;
    /* width: 876px; */
    /* height: 40px; */
    gap: 50px;
}
.editlabel{
    font-family: "Inter";
    font-size: 14px;
    font-weight: 600;
    line-height: 16.94px;
    letter-spacing: 0.02em;
    text-align: left;
    color: #002C5D;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
/* padding-bottom: 5px; */
}

.download {
cursor: pointer;
line-height: 3;
color:#0079E9;
font-weight: bold;
}

.editvalue{
font-family: "Inter";
font-size: 16px;
font-weight: 700;
line-height: 19px;
letter-spacing: 0.02em;
text-align: left;
color:  #0079E9;
padding-top: 10px;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;


}
.editvalueimg{
    font-family: "Inter";
font-size: 16px;
font-weight: 700;
line-height: 19px;
letter-spacing: 0.02em;
text-align: left;
color:  #0079E9;
padding-top: 10px;
text-decoration: underline;

}

.resetChanges{
width:  163px !important;
height:  39px !important;
border-radius: 3px !important;
background-color:#E5F0FC !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;
color: #375370 !important;

}

.cancelButton{
    width: 97px !important ;
height: 39px !important;

border-radius: 3px;
border: 1px solid #FE602F !important;
color:#FE602F !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;

}
.saveButton{
width: 80px !important;
height: 39px !important;
/* padding: 10px, 20px, 10px, 20px */
border-radius: 3px !important;
background-color: #FE602F !important;
color: #FFFFFF !important;
font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19px !important;
letter-spacing: 0.02em !important;
text-align: center !important;

}

.editButton{
    /* width: 80px !important; */
    /* height: 39px !important; */
    /* padding: 10px, 20px, 10px, 20px */
    /* border-radius: 3px !important; */
    background-color: #FE602F !important;
    color: #FFFFFF !important;
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19px !important;
    letter-spacing: 0.02em !important;
    text-align: center !important;
    width: 72px;
height: 39px;
border-radius: 3px;
gap: 10px;
border: none;

}
.css-z3c6am-MuiFormControl-root-MuiTextField-root{
    /* width: 100% !important; */
    /* border: 1.5px solid #B2D4F8 !important; */
    border-radius: 5px !important;
   
}
  
.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{
    /* width: 100% !important; */
 

}


.subHeadingforinfos{
font-family: "Inter";
font-size: 16px;
font-weight: 700;
line-height: 19px;
letter-spacing: 0.02em;
text-align: left;
color:#002C5D

}


.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{
    /* border-color: red !important; */
    /* border: 2px solid #B2D4F8 !important; */
}

.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input :hover{
    border:none !important;
    border-radius: 5px !important;
 }



 .css-13jowp9-MuiInputBase-root-MuiOutlinedInput-root{
    /* border: 1.5px solid #B2D4F8 !important; */
    border-radius: 5px !important;

 }

 /* My Reportees */
 .reportees-main {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
 }

 .reportees-employee-card {
    width: 200px;
    padding: 10px;
    background: #f1f1f1 !important;
 }

 .reportees-employee-subcard {
    padding: 10px;
    word-wrap: break-word;
 }

.previous-experience-parent {
    text-align: right;
}

.previous-experience-btn {
    background-color: hsl(14, 99%, 59%) !important;
    color: white !important;
    text-transform: capitalize;
    font-weight: bold;
}
 `, "",{"version":3,"sources":["webpack://./src/views/panel/editEmployee/EditAddEmployee.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;;AAGA;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;IACb,oBAAoB;IACpB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B,yBAAyB;AACzB;;AAEA;AACA,eAAe;AACf,cAAc;AACd,aAAa;AACb,iBAAiB;AACjB;;AAEA;AACA,oBAAoB;AACpB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB,gBAAgB;AAChB,uBAAuB;;;AAGvB;AACA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,0BAA0B;;AAE1B;;AAEA;AACA,wBAAwB;AACxB,wBAAwB;AACxB,6BAA6B;AAC7B,mCAAmC;AACnC,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;AAC7B,yBAAyB;;AAEzB;;AAEA;IACI,uBAAuB;AAC3B,uBAAuB;;AAEvB,kBAAkB;AAClB,oCAAoC;AACpC,wBAAwB;AACxB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;;AAE7B;AACA;AACA,sBAAsB;AACtB,uBAAuB;AACvB,oCAAoC;AACpC,6BAA6B;AAC7B,oCAAoC;AACpC,yBAAyB;AACzB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,4BAA4B;AAC5B,iCAAiC;AACjC,6BAA6B;;AAE7B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,oCAAoC;IACpC,mCAAmC;IACnC,oCAAoC;IACpC,yBAAyB;IACzB,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;IAC5B,iCAAiC;IACjC,6BAA6B;IAC7B,WAAW;AACf,YAAY;AACZ,kBAAkB;AAClB,SAAS;AACT,YAAY;;AAEZ;AACA;IACI,4BAA4B;IAC5B,4CAA4C;IAC5C,6BAA6B;;AAEjC;;AAEA;IACI,4BAA4B;;;AAGhC;;;AAGA;AACA,oBAAoB;AACpB,eAAe;AACf,gBAAgB;AAChB,iBAAiB;AACjB,sBAAsB;AACtB,gBAAgB;AAChB;;AAEA;;;AAGA;IACI,kCAAkC;IAClC,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;CAChC;;;;CAIA;IACG,4CAA4C;IAC5C,6BAA6B;;CAEhC;;CAEA,iBAAiB;CACjB;IACG,aAAa;IACb,SAAS;IACT,eAAe;CAClB;;CAEA;IACG,YAAY;IACZ,aAAa;IACb,8BAA8B;CACjC;;CAEA;IACG,aAAa;IACb,qBAAqB;CACxB;;AAED;IACI,iBAAiB;AACrB;;AAEA;IACI,8CAA8C;IAC9C,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;AACrB","sourcesContent":[".editpersonalInfo-logo{\n    width: 40px;\nheight: 40px\n\n\n}\n.EditInfoCont{\n    background-color: white !important;\n    /* width:100%; */\n    padding: 20px;\n    /* margin: 0 auto; */\n    /* margin-right: 2% !important; */\n    border-radius: 10px;\n}\n\n.editacc-title{\n    align-self: center;\n    font-family: \"Inter\";\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 19px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color:#00162E !important;\n    /* width: 876px; */\n    /* height: 40px; */\n    gap: 50px;\n}\n.editlabel{\n    font-family: \"Inter\";\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 16.94px;\n    letter-spacing: 0.02em;\n    text-align: left;\n    color: #002C5D;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n/* padding-bottom: 5px; */\n}\n\n.download {\ncursor: pointer;\nline-height: 3;\ncolor:#0079E9;\nfont-weight: bold;\n}\n\n.editvalue{\nfont-family: \"Inter\";\nfont-size: 16px;\nfont-weight: 700;\nline-height: 19px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:  #0079E9;\npadding-top: 10px;\nwhite-space: nowrap;\noverflow: hidden;\ntext-overflow: ellipsis;\n\n\n}\n.editvalueimg{\n    font-family: \"Inter\";\nfont-size: 16px;\nfont-weight: 700;\nline-height: 19px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:  #0079E9;\npadding-top: 10px;\ntext-decoration: underline;\n\n}\n\n.resetChanges{\nwidth:  163px !important;\nheight:  39px !important;\nborder-radius: 3px !important;\nbackground-color:#E5F0FC !important;\nfont-family: \"Inter\" !important;\nfont-size: 16px !important;\nfont-weight: 600 !important;\nline-height: 19px !important;\nletter-spacing: 0.02em !important;\ntext-align: center !important;\ncolor: #375370 !important;\n\n}\n\n.cancelButton{\n    width: 97px !important ;\nheight: 39px !important;\n\nborder-radius: 3px;\nborder: 1px solid #FE602F !important;\ncolor:#FE602F !important;\nfont-family: \"Inter\" !important;\nfont-size: 16px !important;\nfont-weight: 600 !important;\nline-height: 19px !important;\nletter-spacing: 0.02em !important;\ntext-align: center !important;\n\n}\n.saveButton{\nwidth: 80px !important;\nheight: 39px !important;\n/* padding: 10px, 20px, 10px, 20px */\nborder-radius: 3px !important;\nbackground-color: #FE602F !important;\ncolor: #FFFFFF !important;\nfont-family: \"Inter\" !important;\nfont-size: 16px !important;\nfont-weight: 600 !important;\nline-height: 19px !important;\nletter-spacing: 0.02em !important;\ntext-align: center !important;\n\n}\n\n.editButton{\n    /* width: 80px !important; */\n    /* height: 39px !important; */\n    /* padding: 10px, 20px, 10px, 20px */\n    /* border-radius: 3px !important; */\n    background-color: #FE602F !important;\n    color: #FFFFFF !important;\n    font-family: \"Inter\" !important;\n    font-size: 16px !important;\n    font-weight: 600 !important;\n    line-height: 19px !important;\n    letter-spacing: 0.02em !important;\n    text-align: center !important;\n    width: 72px;\nheight: 39px;\nborder-radius: 3px;\ngap: 10px;\nborder: none;\n\n}\n.css-z3c6am-MuiFormControl-root-MuiTextField-root{\n    /* width: 100% !important; */\n    /* border: 1.5px solid #B2D4F8 !important; */\n    border-radius: 5px !important;\n   \n}\n  \n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{\n    /* width: 100% !important; */\n \n\n}\n\n\n.subHeadingforinfos{\nfont-family: \"Inter\";\nfont-size: 16px;\nfont-weight: 700;\nline-height: 19px;\nletter-spacing: 0.02em;\ntext-align: left;\ncolor:#002C5D\n\n}\n\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input{\n    /* border-color: red !important; */\n    /* border: 2px solid #B2D4F8 !important; */\n}\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input :hover{\n    border:none !important;\n    border-radius: 5px !important;\n }\n\n\n\n .css-13jowp9-MuiInputBase-root-MuiOutlinedInput-root{\n    /* border: 1.5px solid #B2D4F8 !important; */\n    border-radius: 5px !important;\n\n }\n\n /* My Reportees */\n .reportees-main {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n }\n\n .reportees-employee-card {\n    width: 200px;\n    padding: 10px;\n    background: #f1f1f1 !important;\n }\n\n .reportees-employee-subcard {\n    padding: 10px;\n    word-wrap: break-word;\n }\n\n.previous-experience-parent {\n    text-align: right;\n}\n\n.previous-experience-btn {\n    background-color: hsl(14, 99%, 59%) !important;\n    color: white !important;\n    text-transform: capitalize;\n    font-weight: bold;\n}\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
